/**
 * @from https://www.w3resource.com/javascript/form/email-validation.php
 */
export function validateEmail(email: string) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}
